const setA2PRestrictionByCompany = function (state, isRestricted: boolean) {
    console.log("SETTING A2P RESTRICTION BY COMPANY")
    state.isA2PRestrictedByCompany = isRestricted
  }
  
export default setA2PRestrictionByCompany
  